import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import "./InvoiceComponent.css";
import InvoiceItem from "./fragments/InvoiceItem";
import Arrows from "./fragments/Arrows";

export default function InvoiceComponent() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [continuationToken, setContinuationToken] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const outletContext = useOutletContext();

  // aggiorna il loader centrale
  useEffect(() => {
    if (outletContext) outletContext.loading = loading;
  }, [loading, outletContext]);

  const fetchInvoices = async (token = null) => {
    setLoading(true);
    try {
      const url = token
        ? `https://homelab.accesso-italiano.it/gui/invoices?continuationToken=${encodeURIComponent(token)}&limit=${itemsPerPage}`
        : `https://homelab.accesso-italiano.it/gui/invoices?limit=${itemsPerPage}`;

      const res = await fetch(url, {
        headers: { "X-EXT-APP-KEY": "ai-netlify-app" },
      });
      const data = await res.json();

      if (token) {
        setInvoices((prev) => [...prev, ...(data.items || [])]);
      } else {
        setInvoices(data.items || []);
        setCurrentPage(1); // reset pagina se è la prima fetch
      }

      setContinuationToken(data.nextContinuationToken || null);
      setHasMore(data.hasMore || false);
    } catch (err) {
      console.error("Errore fetch invoices:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchNext = async () => {
    if (continuationToken) {
      await fetchInvoices(continuationToken);
      setCurrentPage((prev) => prev + 1);
    }
  };

  const prevPage = async () => {
    await fetchInvoices(null);
  };

  // calcola gli elementi visibili in base alla pagina corrente
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleInvoices = invoices.slice(startIndex, endIndex);

  return (
    <>
      <div className="invoice-init shadow-drop-invoice-bottom">
        <div className="invoice-init-left">Fatture</div>
        <div className="invoice-init-right">
          <div className="invoice-init-right__left">Pagina</div>
          <Arrows
            currentPage={currentPage}
            hasMore={hasMore}
            fetchNext={fetchNext}
            prevPage={prevPage}
          />
        </div>
      </div>

      <div className="invoice-container">
        {visibleInvoices.map((inv, idx) => (
          <InvoiceItem key={idx} invoice={inv} />
        ))}
      </div>
    </>
  );
}
